/*
 * @Author: Json Chen
 * @Date: 2021-07-15 18:14:46
 * @LastEditTime: 2021-09-18 14:03:38
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logistics/shippingRate.ts
 */

import { get, post, remove } from 'src/tools/server';

export const getShippingZoneList = (params?) =>
  get<any>(`/portal/setting/store/logistics/shippingZones`, params || {});

export const getShippingZoneDetail = (uuid) =>
  get<any>(`/portal/setting/store/logistics/shippingZone/${uuid}`, {});

export const delShippingZone = (uuid) =>
  remove<any>(`/portal/setting/store/logistics/shippingZone/${uuid}`, {});

// onSave
export const setShippingZone = (body: any) =>
  post<any>(`/portal/setting/store/logistics/shippingZone`, body, {});

export const getShippingRateList = () =>
  get<any>(`/portal/setting/store/logistics/shippingRates`, {});

export const getShippingRateDetail = (uuid) =>
  get<any>(`/portal/setting/store/logistics/shippingRate/${uuid}`, {});

export const delShippingRate = (uuid) =>
  remove<any>(`/portal/setting/store/logistics/shippingRate/${uuid}`, {});

// onSave
export const setShippingRate = (body: any) =>
  post<any>(`/portal/setting/store/logistics/shippingRate`, body, {});

export const setShippingRateSetting = (body: any) =>
  post<any>(`/portal/setting/store/logistics/logisticsSetting`, body, {});

export const getShippingRateSetting = () =>
  get<any>(`/portal/setting/store/logistics/logisticsSetting`, {});
